import { Nullable } from '@/types/common';
import { MicGraph } from '@/types/microphone';
import getScaledLevel from '@/utils/chat/microphone/getScaledLevel';
import { MIC_MAX_RADIUS, MIC_MIN_RADIUS } from '@/utils/constants/microphone';

export const useMicEffect = () => {
  const outerRadius = ref<number>(0);
  const animationId = ref<Nullable<number>>(null);

  const setupMicEffect = (micGraph: Nullable<Ref<MicGraph>>) => {
    if (micGraph && micGraph.value.analyser) {
      const draw = (): void => {
        if (!micGraph?.value) {
          return;
        }
        animationId.value = requestAnimationFrame(draw);

        let r = getScaledLevel(micGraph.value.analyser);
        if (r > MIC_MAX_RADIUS) {
          r = MIC_MAX_RADIUS;
        } else if (r < MIC_MIN_RADIUS) {
          r = MIC_MIN_RADIUS;
        }
        outerRadius.value = r;
      };
      draw();
    }
  };

  const teardownMicEffect = () => {
    if (animationId.value !== null) {
      cancelAnimationFrame(animationId.value);
      animationId.value = null;
      outerRadius.value = MIC_MIN_RADIUS;
    }
  };

  return {
    outerRadius,
    setupMicEffect,
    teardownMicEffect,
  };
};
